import {
  IsString,
  IsNotEmpty,
  IsOptional,
  Length,
  IsUUID,
  IsNumberString,
} from 'class-validator';

import {
  REQUIRED_FIELD_VALIDATION_MESSAGE,
  SMS_CODE_LENGTH,
} from '../../constants';

export class LoginAliDto {
  @Length(SMS_CODE_LENGTH, SMS_CODE_LENGTH, {
    message: 'Вы указали неверный код',
    groups: ['form'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: 'Вы указали неверный код',
      groups: ['form'],
    },
  )
  @IsNotEmpty({
    groups: ['form'],
    message: 'Вы забыли ввести код',
  })
  @IsString({
    groups: ['form'],
    message: 'Вы забыли ввести код',
  })
  code: string;

  @IsOptional()
  @IsUUID()
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  passCode?: string;

  @IsOptional()
  @IsUUID()
  @IsString()
  authInstanceId?: string;
}
